import React from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import {
  bindMenu,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import Stack from '@mui/material/Stack';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuList from '@mui/material/Menu';

const CustomSelect = ({
  label,
  value,
  onChange,
  size,
  options,
  margin = 'normal',
  fullWidth,
  hasError,
  hint,
  helpText,
  sx,
}) => {
  const popupState = usePopupState({
    popupId: 'select',
  });

  const handleSelect = (val) => {
    onChange(val);
    popupState.close();
  };

  return (
    <FormControl
      size={size}
      variant="standard"
      margin={margin}
      sx={sx}
      fullWidth={fullWidth}
      error={hasError}
    >
      {label && <FormLabel sx={{ mb: 1 }}>{label}</FormLabel>}
      <Paper
        variant="outlined"
        {...bindTrigger(popupState)}
        sx={{
          p: 1,
          cursor: 'pointer',
          borderColor: popupState.isOpen && 'primary.main',
        }}
      >
        <Stack spacing={2} direction="row" alignItems="center">
          <img
            style={{ height: 40 }}
            src={options.find((i) => i.value === value)?.img}
          />
          <Typography sx={{ flex: 1 }}>
            {value
              ? options.find((i) => i.value === value)?.label
              : 'Please select'}
          </Typography>
          <ExpandMoreIcon />
        </Stack>
      </Paper>
      <MenuList
        {...bindMenu(popupState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        MenuListProps={{
          sx: { width: popupState.anchorEl?.offsetWidth },
        }}
      >
        {options.map((option, idx) => (
          <MenuItem
            key={idx}
            onClick={() => handleSelect(option.value)}
            selected={option.value === value}
          >
            <ListItemIcon sx={{ mr: 2 }}>
              <img src={option.img} style={{ width: 50 }} />
            </ListItemIcon>
            <ListItemText>{option.label}</ListItemText>
          </MenuItem>
        ))}
      </MenuList>
      {hint && (
        <Typography variant="caption" color="textSecondary">
          {hint}
        </Typography>
      )}
      {hasError && <FormHelperText>{helpText}</FormHelperText>}
    </FormControl>
  );
};

export default React.forwardRef((props, ref) => {
  return <CustomSelect {...props} ref={ref} />;
});
